import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';

import { FormControl, CheckboxGroup, Checkbox } from '@client:common/form';

import { BaseFilter } from '../filter-bar/FilterBar';

import './FilterSection.light.scss';
import './FilterSection.dark.scss';

interface FilterSectionProps {
  title: string;
  filters: {
    info?: Array<{ id: number; title: string; description: string }>;
    filters: Array<{ id: number; value: string }>;
  };
  selected: BaseFilter;
  setSelected: (value: BaseFilter) => void;
  applyFilter: (selectedValues: any, group: string) => void;
  group: string;
}

const FilterSection = ({ title, filters: filterData, selected, setSelected, applyFilter, group }: FilterSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const selectedCount = selected.selected?.length || 0;

  const formControl = new FormControl(selected.selected || []);

  const handleCheckboxChange = (updatedSelected: Array<{ id: number; value: string }>) => {
    setSelected({ ...selected, selected: updatedSelected });
    applyFilter(updatedSelected, group);
  };

  const handleClick = (e: React.MouseEvent) => {
    if (e.type === 'click') {
      e.stopPropagation();
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className="filter-section">
      <div
        className="filter-section-header"
        onClick={handleClick}
      >
        <div className="filter-section-title">
          <span>{title}</span>
          {selectedCount > 0 && !isExpanded && (
            <span className="selected-count">
              ({selectedCount})
            </span>
          )}
        </div>
        <motion.span
          className="material-icons"
          animate={{ rotate: isExpanded ? 90 : 0 }}
          transition={{ duration: 0.3 }}
        >
          chevron_right
        </motion.span>
      </div>
      {!isExpanded && selectedCount > 0 && (
        <div className="filter-section-summary">
          {selected.selected?.map((item, index) => (
            <span key={item.id}>
              {item.value}
              {index < selectedCount - 1 ? ', ' : ''}
            </span>
          ))}
        </div>
      )}
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            className="filter-section-content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <CheckboxGroup formControl={formControl}>
              {filterData.filters.map((item: { id: number; value: string }) => (
                <Checkbox
                  key={item.id}
                  value={item}
                  label={item.value}
                  checked={selected.selected?.some(i => i.id === item.id)}
                  onChange={() => handleCheckboxChange(formControl.getValue())}
                />
              ))}
            </CheckboxGroup>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FilterSection;
